import { render, staticRenderFns } from "./view-caselabel-serials-expand.vue?vue&type=template&id=3ed8edf6&scoped=true&"
import script from "./view-caselabel-serials-expand.vue?vue&type=script&lang=js&"
export * from "./view-caselabel-serials-expand.vue?vue&type=script&lang=js&"
import style0 from "./view-caselabel-serials-expand.vue?vue&type=style&index=0&id=3ed8edf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8edf6",
  null
  
)

export default component.exports